import { render, staticRenderFns } from "./InventoryGoods.vue?vue&type=template&id=7b187e30&scoped=true"
import script from "./InventoryGoods.vue?vue&type=script&lang=js"
export * from "./InventoryGoods.vue?vue&type=script&lang=js"
import style0 from "./InventoryGoods.vue?vue&type=style&index=0&id=7b187e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b187e30",
  null
  
)

export default component.exports